import { actionNameGenerator } from "../../utils/commonUtil";

const domainPrefix = "myAccount";
const myAccountActionNameGenerator = actionNameGenerator(domainPrefix);

export const postInviteType = myAccountActionNameGenerator("postInvite");
export const postInviteSuccessType = myAccountActionNameGenerator("postInviteSuccess");
export const postInviteErrorType = myAccountActionNameGenerator("postInviteError");
export const clearInvitePartyType = myAccountActionNameGenerator("clearIipSubmit");
export const clearInvitePartyTypeError = myAccountActionNameGenerator("clearIpIsError");
export const hide504Error = myAccountActionNameGenerator("hide504Error");
export const updateStepNameType = myAccountActionNameGenerator("updateActivePageStepName");
export const jsonTempType = myAccountActionNameGenerator("jsonTemp");
export const isSecAdvType = myAccountActionNameGenerator("isSecondaryAdvisor");
export const updateDropDownValType = myAccountActionNameGenerator("updateDropdownValues");
export const myAccMandatoryType = myAccountActionNameGenerator("myAccountMandatoryMissing");

export const resetFormAddrType = myAccountActionNameGenerator("handleResetFormAddress");
export const resetFormPhoneType = myAccountActionNameGenerator("handleResetFormPhone");
export const resetFormEmailType = myAccountActionNameGenerator("handleResetFormEmail");
export const resetFormType = myAccountActionNameGenerator("handleResetFormInfo");
export const resetType = myAccountActionNameGenerator("reset");
export const addAdvBtnDisableType = myAccountActionNameGenerator("disableButton");

export const resetFormContributorType = myAccountActionNameGenerator("handleResetFormRelatedContributor");
export const step1EditType = myAccountActionNameGenerator("step1Edit");
export const postAccountAdvType = myAccountActionNameGenerator("postAccountAdvisor");
export const postAccountAdvErrType = myAccountActionNameGenerator("postAccountAdvisorErr");

export const clearEditProfileErrorType = myAccountActionNameGenerator("clearEditProfileError");
export const addSecondaryAdvisorType = myAccountActionNameGenerator("addSecondaryAdvisor");
export const addSecondaryAdvSuccType = myAccountActionNameGenerator("addSecondaryAdvSuccess");
export const addSecondaryAdvFailureType = myAccountActionNameGenerator("addSecondaryAdvFailure");

export const clearSecAdvType = myAccountActionNameGenerator("clearSecondaryAdvRes");
export const clearSecAdvFormType = myAccountActionNameGenerator("handleResetSecFormBasicInfo");
export const prefilPrimaryValType = myAccountActionNameGenerator("prefillValuesInfoPrimary");
export const prefilSecondaryValType = myAccountActionNameGenerator("prefillValuesInfoSecondary");

export const handleInfoChangeType = myAccountActionNameGenerator("handleInfoChange");
export const savePrimaryInfoType = myAccountActionNameGenerator("savePrimaryInfo");
export const changePhoneHandlerType = myAccountActionNameGenerator("onPhoneChangeHandler");
export const prefilPrimaryPhoneValType = myAccountActionNameGenerator("prefillValuesPhonePrimary");
export const prefilSecondaryPhoneValType = myAccountActionNameGenerator("prefillValuesPhoneSecondary");

export const emailChangeHandlerType = myAccountActionNameGenerator("onEmailChangeHandler");
export const prefilPrimaryValuesType = myAccountActionNameGenerator("prefillValuesPrimary");
export const prefilSecValuesType = myAccountActionNameGenerator("prefillValuesSecondary");

export const changeAddressHandlerType = myAccountActionNameGenerator("onAddressChangeHandler");
export const prefilPrimaryAddrValType = myAccountActionNameGenerator("prefillValuesAddressPrimary");
export const prefilSecAddrValType = myAccountActionNameGenerator("prefillValuesAddressSec");

export const fetchZipCode = myAccountActionNameGenerator("fetchZipCode");
export const emptyZipType = myAccountActionNameGenerator("emptyZip");

export const handleRadioChangePrimaryType = myAccountActionNameGenerator("handleRadioChangePrimary");
export const handleRadioChangeSecondaryType = myAccountActionNameGenerator("handleRadioChangeSecondary");

export const profileJsonTempType = myAccountActionNameGenerator("profileJsonTemp");

export const postProfileType = myAccountActionNameGenerator("postProfile");
export const postProfileErrorType = myAccountActionNameGenerator("postProfileErr");

export const displaySuccessionValType = myAccountActionNameGenerator("successionVal");
export const displaySuccessionValLoaderType = myAccountActionNameGenerator("successionLoaderVal");
export const displaySuccessionValSuccessType = myAccountActionNameGenerator("successionValSuccess");
export const displaySuccessionValFailureType = myAccountActionNameGenerator("successionValFailure");

export const fetchDropDownValType = myAccountActionNameGenerator("fetchDropdownValues");
export const fetchDropDownLoaderValType = myAccountActionNameGenerator("fetchDropdownValueLoader");

export const fetchRelationDropDownLoaderValType = myAccountActionNameGenerator("fetchRelationDropdownValLoader");
export const fetchRelationDropDownSuccessType = myAccountActionNameGenerator("fetchRelationDropdownValSuccess");
export const fetchRelationDropDownFailureType = myAccountActionNameGenerator("fetchRelationDropdownValFailure");

export const grantOptionPdfType = myAccountActionNameGenerator("grantOptionPdf");
export const successPoliciesType = myAccountActionNameGenerator("successPolicies");
export const failedPoliciesType = myAccountActionNameGenerator("failedPolicies");
export const endowedSuccessType = myAccountActionNameGenerator("endowedSuccess");
export const endowedFailureType = myAccountActionNameGenerator("endowedFailure");

export const legacyValuesFromApiType = myAccountActionNameGenerator("legacyValuesFromApi");
export const resetLegacyFromApiType = myAccountActionNameGenerator("resetLegacyFromApi");
export const resetLegacyType = myAccountActionNameGenerator("resetLegacy");
export const updateSuccessionType = myAccountActionNameGenerator("updateSuccession");
export const updateLegacyFailureType = myAccountActionNameGenerator("updateLegacyFailure");

export const doesOthersExistType = myAccountActionNameGenerator("doesOthersExist");
export const saveOptionDataType = myAccountActionNameGenerator("saveOptionData");
export const removeValuesType = myAccountActionNameGenerator("removeValues");
export const showRemainingPercentageType = myAccountActionNameGenerator("showRemainingPercentage");
export const savePercentageType = myAccountActionNameGenerator("savePercentage");

export const errorVariableType = myAccountActionNameGenerator("errorVariable");
export const addSuccessorType = myAccountActionNameGenerator("addSuccessor");
export const saveSuccessorValuesType = myAccountActionNameGenerator("saveSuccessorValues");
export const shouldCloseType = myAccountActionNameGenerator("shouldClose");
export const udpateValidLegacyFormType = myAccountActionNameGenerator("updateLegacyFormValid");
export const designatedData = myAccountActionNameGenerator("designatedData");
export const designatedDataSuccType = myAccountActionNameGenerator("designatedDataSuccess");
export const designatedDataLoaderType = myAccountActionNameGenerator("designatedUpdateLoader");
export const designatedDataFailureType = myAccountActionNameGenerator("designatedDataFailure");

export const fetchMyAccDataType = myAccountActionNameGenerator("fetchMyAccData");
export const fetchMyAccDataLoaderType = myAccountActionNameGenerator("fetchMyAccDataLoader");
export const myAccDataType = myAccountActionNameGenerator("myAccData");
export const myAccDataFailedType = myAccountActionNameGenerator("myAccDataFailed");
export const fetchMyAccMappingType = myAccountActionNameGenerator("fetchMyAccountMapping");
export const countriesListType = myAccountActionNameGenerator("countriesList");
export const countriesListFailedType = myAccountActionNameGenerator("countriesListFailed");

export const resetDesignatedDataType = myAccountActionNameGenerator("resetDesignatedDataSuccess");
export const changeNameType = myAccountActionNameGenerator("changeName");
export const saveNewFundNameType = myAccountActionNameGenerator("newFundName");
export const saveNewFundNameSuccessType = myAccountActionNameGenerator("newFundNameSuccess");
export const handle504Error = myAccountActionNameGenerator("handle504Error");

export const changePrimaryType = myAccountActionNameGenerator("changePrimary");
export const savePrimaryAccountType = myAccountActionNameGenerator("savePrimaryAccount");
export const primaryContactLoadingType = myAccountActionNameGenerator("primaryContactLoading");
export const primaryContactSuccessType = myAccountActionNameGenerator("primaryContactSuccess");
export const myAccDataSuccessType = myAccountActionNameGenerator("myAccDataSuccess");
export const primaryContactMyAccSuccessType = myAccountActionNameGenerator("primaryContactMyAccSuccessType");
export const primaryContactFailedType = myAccountActionNameGenerator("primaryContactFailedType");

export const newFundNameToSaveType = myAccountActionNameGenerator("newFundNameForSave");
export const addDesignatedType = myAccountActionNameGenerator("addDesignated");
export const addDesgnatedSuccess = myAccountActionNameGenerator("addDesgnatedSuccess");
export const addDesignatedFailedType = myAccountActionNameGenerator("addDesignatedFailed");

export const relatedContributorPrimaryType = myAccountActionNameGenerator("relatedContributorPrimary");
export const relatedContributorSecondaryType = myAccountActionNameGenerator("relatedContributorSecondary");

export const myProfileDataSuccessType = myAccountActionNameGenerator("myProfileDataSuccess");
export const myProfileDataType = myAccountActionNameGenerator("myProfileData");
export const myProfileDataFailureType = myAccountActionNameGenerator("myProfileDataFailure");

export const showComponentType = myAccountActionNameGenerator("showComponent");
export const hideComponentType = myAccountActionNameGenerator("hideComponent");
export const tableDataSuccessType = myAccountActionNameGenerator("tableDataUpdate");
export const tableDataUpdateSuccType = myAccountActionNameGenerator("tableDataUpdSucc");
export const defaultUpdateType = myAccountActionNameGenerator("defaultUpdate");
export const tableDataUpdFailureType = myAccountActionNameGenerator("tableDataUdpFailure");

export const tabaleDataSuccessType = myAccountActionNameGenerator("tableDataSuccess");
export const tableDataFailureType = myAccountActionNameGenerator("tableDataFailure");

export const correctResUserType = myAccountActionNameGenerator("correctResUser");
export const inCorrectResUserType = myAccountActionNameGenerator("inCorrectResUserType");
export const clearChangeUserIdType = myAccountActionNameGenerator("clearChangeUserId");
export const clearUpdUserIdType = myAccountActionNameGenerator("clearUpdUserId");
export const clearErrMessageType = myAccountActionNameGenerator("clearErrMessage");
export const UpdateNewUserIdType = myAccountActionNameGenerator("UpdateNewUserId");

export const correctResmfaEmailType = myAccountActionNameGenerator("correctResmfaEmail");
export const inCorrectResmfaEmailType = myAccountActionNameGenerator("inCorrectResmfaEmailType");
export const clearChangemfaEmailType = myAccountActionNameGenerator("clearChangemfaEmail");
export const clearUpdmfaEmailType = myAccountActionNameGenerator("clearUpdmfaEmail");
export const clearmfaEmailErrMessageType = myAccountActionNameGenerator("clearmfaEmailErrMessage");
export const UpdateNewmfaEmailType = myAccountActionNameGenerator("UpdateNewmfaEmail");
export const mfaEmailExistType = myAccountActionNameGenerator("mfaEmailExists");
export const updatedmfaEmailApiResType = myAccountActionNameGenerator("updatedmfaEmailApiRes");
export const mfaEmailExistsType = myAccountActionNameGenerator("mfaEmailExits");
export const mfaEmailSuccessType = myAccountActionNameGenerator("mfaEmailSuccess");
export const mfaEmailFailureType = myAccountActionNameGenerator("mfaEmailFailure");

export const userIndExistType = myAccountActionNameGenerator("userIdExists");
export const updatedUserIdApiResType = myAccountActionNameGenerator("updateduserIdApiRes");
export const userIdExistsType = myAccountActionNameGenerator("userIdExits");
export const userIdSuccessType = myAccountActionNameGenerator("userIdSuccess");

export const generateAccessKeyType = myAccountActionNameGenerator("generateAccessKey");
export const accessKeySuccessType = myAccountActionNameGenerator("accessKeySuccess");
export const accessKeyFailureType = myAccountActionNameGenerator("accessKeyFailure");

export const addDecrementCountType = myAccountActionNameGenerator("addDecrementCount");
export const myProfileDetails = myAccountActionNameGenerator("myProfileData");
export const myProfileDetailsFailure = myAccountActionNameGenerator("myProfileDataFailure");

export const resendEmailType = myAccountActionNameGenerator("resendEmail");
export const resendEmailSuccessType = myAccountActionNameGenerator("resendEmailSuccess");
export const resendEmailFailureType = myAccountActionNameGenerator("resendEmailFailure");
export const resendEmailClearFlagType = myAccountActionNameGenerator("resendEmailClearFlag");

export const changeMFAPhNoType = myAccountActionNameGenerator("changeMFAPhNo");
export const changeMFAPhNoSuccessType = myAccountActionNameGenerator("changeMFAPhNoSuccess");
export const changeMFAPhNoFailureType = myAccountActionNameGenerator("changeMFAPhNoFailure");
export const changeMFAPhNoClearFlagType = myAccountActionNameGenerator("changeMFAPhNoClearFlag");
export const refreshMFAPhNoComType = myAccountActionNameGenerator("refreshMFAPhNoCom");
export const selectSuccessionPlanType = myAccountActionNameGenerator("selectSuccessionPlan");
export const espSubmitLoader = myAccountActionNameGenerator('espSubmitLoader');
export const esphideSubmitLoader = myAccountActionNameGenerator('esphideSubmitLoader');